<template>
  <modal
    name="show-fullscreen-image"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    height="auto"
    width="90%"
    :clickToClose="false"
    @before-open="getData"
  >
    <div class="modalWrapper">
      <div class="text-center">
        <img
          class="img-fluid"
          :src="image"
          alt="Audit Image"
        />
      </div>

      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "ShowFullScreenImage",
  data() {
    return {
      image: "",
    }
  },
  methods: {
    closeModal() {
      this.$modal.hide("show-fullscreen-image");
    },
    getData(e) {
      this.image = e.params.image;
    }
  },
};
</script>

<style>
</style>